import { Component, OnInit } from '@angular/core';
import {TokenStorageService} from '../../../shared/service/token-storage.service';
import {PageDTO} from '../../../shared/dto/page.model';
import {UserPrivilegeService} from '../../../shared/service/user-privilege.service';
import {SidebarItem} from '../../../shared/dto/sidebar-item.model';
import {UserPrivilegeSearchModel} from '../../../shared/dto/user-privilege-search.model';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  userRole: string;
  public pages: PageDTO[];
  public userPrivileges: UserPrivilegeSearchModel [] = [];
  public menuItems: SidebarItem[] = [];
  public haseAdm: boolean = false;

  selectedMenu = 1;
  constructor(private tokenStorageService: TokenStorageService,
              private userPrivilegeService: UserPrivilegeService) {
    this.userRole = this.tokenStorageService.getUserObjectToken().userroleCode;
    this.pages = this.tokenStorageService.getUserObjectToken().pages;
  }

  ngOnInit() {
    this.loadUserPrivileges(this.userRole);
  }

  loadUserPrivileges(userRole: string){
    this.userPrivilegeService.getUserPrivilegesByUserRole(userRole).subscribe(
      (data: UserPrivilegeSearchModel[])=>{
        this.userPrivileges = data;
      }
    )
  }

  generateSideBarItems() {
    this.getSectionsByUserPrivileges().forEach(
      section => {
        // console.log('Section : ' + section.sectionCode.description);

        let sectionMenuItem = new SidebarItem();
        let subSectionMenuItems: SidebarItem[] = [];
        if (section.subSection1 != null) {
          //If have sub sections
          this.getSubSectionsBySectionInUserPrivileges(section.section1.sectionCode).forEach(
            subSection => {
              // console.log('Sub Section : ' + subSection.subsectionCode.description)
              let subSectionMenuItem = new SidebarItem();
              let pageMenuItems: SidebarItem[] = [];
              //
              if (subSection.page1.pageCode != null) {
                // If have page
                this.getPageBySubSectionInUserPrivileges(subSection.subSection1.subsectionCode).forEach(
                  page => {
                    // console.log('Page : ' + page.pageCode.description);
                    let pageMenuItem = new SidebarItem();
                    pageMenuItem.title = page.page1.description;
                    pageMenuItem.path = page.page1.url;
                    pageMenuItem.icon = '';
                    pageMenuItem.class = '';
                    pageMenuItem.badge = '';
                    pageMenuItem.badgeClass = '';
                    pageMenuItem.isExternalLink = false;
                    pageMenuItem.submenu = [];

                    pageMenuItems.push(pageMenuItem);
                  }
                );
                subSectionMenuItem.class = 'has-sub';
              } else {
                subSectionMenuItem.class = '';
              }
              subSectionMenuItem.title = subSection.subSection1.description;
              // subSectionMenuItem.path = subSection.subSection1.url;
              subSectionMenuItem.icon = '';
              subSectionMenuItem.badge = '';
              subSectionMenuItem.badgeClass = '';
              subSectionMenuItem.isExternalLink = false;
              subSectionMenuItem.submenu = pageMenuItems;
              //
              subSectionMenuItems.push(subSectionMenuItem);

            }
          );
          sectionMenuItem.class = 'has-sub';
        } else {
          sectionMenuItem.class = '';
        }
        sectionMenuItem.title = section.section1.description;
        // sectionMenuItem.path = section.section1.url;
        sectionMenuItem.icon = section.section1.icon;
        sectionMenuItem.badge = '';
        sectionMenuItem.badgeClass = '';
        sectionMenuItem.isExternalLink = false;
        sectionMenuItem.submenu = subSectionMenuItems;

        this.menuItems.push(sectionMenuItem);
        // console.log('sectionMenuItem : ****** : ' + JSON.stringify(sectionMenuItem));
      }
    );
  }

  getSectionsByUserPrivileges(): UserPrivilegeSearchModel[] {

    let userPrivileges: UserPrivilegeSearchModel[] = [];
    this.userPrivileges.forEach(
      (value) => {

        // console.log('For 1 Filter : ')
        // console.log(value.sectionCode.description)
        if (!userPrivileges.some(
          value1 => {
            // console.log('Some : ')
            // console.log(value.sectionCode.description)
            return value.section1 == value1.section1;
          }
        )) {
          // console.log('push : ')
          // console.log(value.sectionCode.description)
          userPrivileges.push(value);
        }
      }
    );
    return userPrivileges;
  }

  getSubSectionsBySectionInUserPrivileges(sectionCode: string): UserPrivilegeSearchModel[] {

    let userPrivileges: UserPrivilegeSearchModel[] = [];
    let userPrivileges2: UserPrivilegeSearchModel[] = [];
    // console.log('sectionCode : ' + sectionCode)

    userPrivileges = this.userPrivileges.filter(
      value => {
        // console.log('For 1 Filter : ')
        // console.log(value.sectionCode.sectionCode)
        return value.section1.sectionCode == sectionCode;
      }
    );
    // console.log(userPrivileges)
    userPrivileges.forEach(
      (value) => {
        // console.log('For 2 Each : ')
        // console.log('For: ' + value.sectionCode.sectionCode + ' : ' + value.subsectionCode.subsectionCode)
        // console.log(value.subsectionCode.subsectionCode)

        if (!userPrivileges2.some(
          value1 => {
            // console.log('For 3 Some : ')
            // console.log('Some: ' + value.sectionCode.sectionCode + ' : ' + value1.sectionCode.sectionCode)
            // console.log(value.subsectionCode.description)
            return value.subSection1 == value1.subSection1;
          }
        )) {
          // console.log('Push: ' + value.subsectionCode.description)
          userPrivileges2.push(value);
        }
      }
    );
    return userPrivileges2;
  }

  getPageBySubSectionInUserPrivileges(subSectionCode: string): UserPrivilegeSearchModel[] {

    let userPrivileges: UserPrivilegeSearchModel[] = [];

    userPrivileges = this.userPrivileges.filter(
      value => {
        if (value.subSection1 != null) {
          return value.subSection1.subsectionCode == subSectionCode;
        }
      }
    );
    return userPrivileges;
  }
}
